import useTranslationHook from "hooks/useTranslationHook";
import { resolveCopy } from "../utils/neighbourhoodHelpers";
import styles from "../neighbourhoodSection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const PLACEHOLDER_ROWS = [0, 1, 2] as const;

const TAB_LABEL_KEYS = [
  "propertypage.components.neighbourhood.tab.costOfLiving",
  "propertypage.components.neighbourhood.tab.gettingAround",
  // "propertypage.components.neighbourhood.tab.safety",
  "propertypage.components.neighbourhood.tab.community",
  "propertypage.components.neighbourhood.tab.climate",
] as const;

const NeighbourhoodSkeleton = () => {
  const { t } = useTranslationHook();

  return (
    <section className={styles.container} data-testid="neighbourhood-skeleton" aria-busy="true">
      <div className={styles.header}>
        <h2>{resolveCopy(t, "propertypage.components.neighbourhood.section.heading")}</h2>
      </div>
      <div className={styles.tabsWrapper}>
        <div className={styles.tabsList} role="tablist" aria-label="Neighbourhood information tabs">
          {TAB_LABEL_KEYS.map((key) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={false}
              className={styles.tab}
              tabIndex={-1}
              disabled
            >
              {resolveCopy(t, key)}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.contentArea}>
        <div className={styles.skeletonHero} />
        <div className={styles.detailsSection}>
          {PLACEHOLDER_ROWS.map((row) => (
            <div key={row} className={styles.skeletonRow} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default wrapperHOC(NeighbourhoodSkeleton, {
  componentName: "PropertyPage-NeighbourhoodSkeleton",
  showForChina: false,
  showForWhiteLable: false,
});
